export default function TrustedByGrowthMindedBrands() {
  return null;
}